import Vue from 'vue'
import VueRouter from 'vue-router'

const originalReplace = VueRouter.prototype.replace
const originalPush = VueRouter.prototype.push
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {//公司动态
    path: '/companyDynamics',
    name: 'companyDynamics',
    component: () => import('../common/CompanyDynamics.vue')
  }, 
  {//新闻详情
    path: '/newDetails',
    name: 'newDetails',
    component: () => import('../common/NewDetails.vue')
  },
  { //业务板块
    path: '/businessSector',
    name: 'businessSector',
    component: () => import('../common/BusinessSector.vue')
  },
  {//业务详情
    path: '/businessSectorDetails',
    name: 'businessSectorDetails',
    component: () => import('../common/BusinessSectorDetails.vue')
  },
  {//业务详情
    path: '/businessSectorDetailsWde',
    name: 'businessSectorDetailsWde',
    component: () => import('../common/businessSectorDetailsWde.vue')
  },
  {//公司介绍
    path: '/companyIntroduction',
    name: 'companyIntroduction',
    component: () => import('../common/CompanyIntroduction.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/chat/index.vue')
  },
]

const router = new VueRouter({
  mode:'history',
  routes
})


router.beforeEach((to, from, next) => {
  document.title = (to.meta.title ? to.meta.title : '中检宁波公司')
  // if (to.query.name) document.title = to.query.name
  next()
  // if (!localStorage.getItem('authToken')) {
  //   if (to.path == '/login') {
  //       next()
  //   } else {
  //     next('/login?address=' + to.path)
  //     }
  // } else {
  //     next()
  // }
})

export default router
